import { StyleSheet, Platform } from 'react-native';
import * as Colors from '../const/Colors'
import { colors, global } from '../const';

const styles = StyleSheet.create({
  mobileContainer: {
    flex: 1,
    alignItems: "center",
    backgroundColor: colors.app_background,
    width: "100%"
  },
  webview: {
    minWidth: 320,
    maxWidth: 414,
    backgroundColor: colors.app_background,
    width: "100%"
  },
  container: {
    flex: 1,
    backgroundColor: colors.app_background
  },
  bgDark: { backgroundColor: Colors.midnightBack },
  bgUltralight: { backgroundColor: Colors.ultralight },
  bgBlue: { backgroundColor: Colors.indigo },
  bgAlert: { backgroundColor: Colors.alert },
  bgDisabled: { backgroundColor: Colors.disable },
  bglightGray: { backgroundColor: Colors.lightGray },
  cW: { color: '#fff' },
  cA: { color: Colors.alert },
  cB: { color: Colors.indigo },
  cD: { color: Colors.midnightBack },
  cGey: { color: Colors.gray },
  containDesc: {
    fontFamily: global.FONT_REGULAR,
    fontWeight: "400",
    fontSize: 18
  },
  errorTitle: {
    fontFamily: global.FONT_REGULAR,
    fontSize: 14,
    color: Colors.alert,
    fontWeight: 'bold'
  },
  headerTitle: {
    fontFamily: global.FONT_BOLD,
    fontWeight: "bold",
    fontSize: 22,
  },
  buttonTitle: {
    fontFamily: global.FONT_BOLD,
    fontWeight: "bold",
    fontSize: 14,
    textTransform: 'uppercase'
  },
  captionNormal: {
    fontFamily: global.FONT_REGULAR,
    fontWeight: "400",
    fontSize: 12,
    textTransform: 'uppercase'
  },
  captionBold: {
    fontFamily: global.FONT_BOLD,
    fontWeight: "bold",
    fontSize: 12,
    textTransform: 'uppercase'
  },
  BodyNormal: {
    fontFamily: global.FONT_REGULAR,
    fontWeight: "400",
    fontSize: 16,
  },
  subHeader: {
    fontFamily: global.FONT_REGULAR,
    fontWeight: "400",
    fontSize: 18,
  },
  BodyBold: {
    fontFamily: global.FONT_BOLD,
    fontWeight: "bold",
    fontSize: 16,
  },
  linkLable: {
    textDecorationLine: 'underline',
    fontFamily: global.FONT_REGULAR,
    fontWeight: "400",
    fontSize: 14,
    textTransform: 'uppercase',
  },
  divider: {
    height: 1,
    backgroundColor: colors.lightGray,
    width: '100%'
  },
  hDivider: {
    height: 18,
    width: 1,
  },
  header: {
    justifyContent: 'space-between',
    alignItems: 'center',
    marginLeft: 0,
    marginRight: 0,
    flexDirection: 'row',
    paddingLeft: 5,
    paddingRight: 5,
    zIndex: 999,
    position: 'relative',
  },
  progressDot: {
    width: 14,
    height: 14,
    backgroundColor: Colors.lightGray,
    borderRadius: 14 / 2,
    margin: 2.5
  },
  fillProgressDot: {
    width: 14,
    height: 14,
    backgroundColor: Colors.indigo,
    borderRadius: 14 / 2,
    margin: 2.5
  },
  or_divider: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  borderGreen: { borderColor: Colors.darkgreen },
  borderGrey: { borderColor: Colors.lightGray },
  borderBlue: { borderColor: Colors.indigo },
  borderAlert: { borderColor: Colors.alert },
  inputField: {
    width: '100%',
    borderRadius: 8,
    borderWidth: 1,
    height: 50,
    backgroundColor: '#fff',
    borderStyle: 'solid',
    flexDirection: 'row',
    alignItems: 'center',
    overflow: "hidden"
  },
  input: {
    fontSize: 20,
    color: Colors.midnightBack,
    fontFamily: global.FONT_REGULAR,
    fontWeight: "400",
    height: "100%",
    paddingHorizontal: 10,
    flex: 1
  },
  squareButton: {
    minHeight: 40,
    minWidth: 40,
    borderRadius: 8,
    justifyContent: 'center',
    alignItems: 'center',
    margin: 5,
  },
  profileAvatar: {
    height: '100%',
    width: '100%',
    backgroundColor: "transparent",
    borderWidth: 1,
    borderColor: Colors.gray,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 100,
    overflow: 'hidden'
  },
  send_msg_container: {
    marginRight: 5,
    backgroundColor: Colors.indigo,
    padding: 8,
    flexDirection: 'column',
    flex: 1,
    flexWrap: 'nowrap',
    borderRadius: 20,
    borderTopRightRadius: 3,
    flexGrow: 1,
    alignSelf: 'stretch',
  },
  lableBg: {
    padding: 3,
    alignSelf: 'center',
    flex: 1,
    marginVertical: 6,
    borderRadius: 6,
    paddingHorizontal: 4
  },
  budge: {
    backgroundColor: '#FE2E47',
    justifyContent: 'center',
    alignItems: 'center',
    height: 16,
    minWidth: 16,
    borderRadius: 16,
    position: 'absolute',
    zIndex: 1
  },
  chatRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 10,
    backgroundColor: '#fff'
  },
  audioComponent: {
    backgroundColor: 'rgb(94, 35, 255)',
    height: 40,
    width: '85%',
    marginRight: 3,
    marginLeft: 2,
    borderRadius: 6,
    alignItems: 'center',
    paddingLeft: 10,
    flexDirection: 'row'
  },
  recordingTimer: {
    height: '75%',
    paddingRight: 10,
    paddingLeft: 5,
    marginLeft: 6,
    borderRadius: 20,
    flexDirection: 'row',
    alignItems: 'center',
  },
  dontChartRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingRight: 50,
    paddingTop: 15,
  },
  titleBox: {
    backgroundColor: "#E5EDF1",
    justifyContent: 'space-between',
    margin: 0,
    alignItems: 'center',
    height: 40,
    paddingLeft: 20,
    paddingRight: 20,
    flexDirection: 'row',
  },
  msgContainerSend: {
    marginRight: 8,
    borderRadius: 20,
    borderTopRightRadius: 3,
    padding: 10,
    flexDirection: 'row',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
  },
  msgContainerReceive: {
    marginLeft: 8,
    borderRadius: 20,
    borderBottomLeftRadius: 3,
    padding: 10,
    // flex: 1,
    flexWrap: 'wrap',
  },
  conversationTitle: {
    backgroundColor: Colors.ultralight,
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 40,
    paddingHorizontal: 20,
    flexDirection: 'row',
  },
  textArea: {
    borderRadius: 8,
    fontFamily: global.FONT_REGULAR,
    fontWeight: "400",
    fontSize: 16,
    color: colors.midnightBack,
    textAlignVertical: 'top',
    borderWidth: 1,
    borderColor: colors.lightGray,
    padding: 5
  },
  rate_point: {
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.1, shadowRadius: 6,
    elevation: 1,
    shadowColor: 'black',
    flexDirection: 'row',
    backgroundColor: '#fff',
    borderRadius: 6,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
    maxHeight: 45
  },
  modalarea: {
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.1, shadowRadius: 6,
    shadowColor: 'black',
    elevation: 5,
    backgroundColor: '#FFF',
    width: '85%',
    borderRadius: 6,
    alignItems: 'center',
    minHeight: 300
  },
  emptyTitle: {
    fontFamily: global.FONT_REGULAR,
    fontWeight: "bold",
    fontSize: 14,
    color: colors.gray
  },
  emptyList: {
    fontFamily: global.FONT_REGULAR,
    fontSize: 12,
    textAlign: "center",
    paddingVertical: 15,
    color: colors.gray
  },
  checkboxRow: {
    flexDirection: "row"
  },
  paper: {
    backgroundColor: colors.white,
    borderRadius: 5,
    elevation: 5,
    borderWidth: 0.1,
    borderColor: colors.lightGray,
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.2, shadowRadius: 5,
    shadowColor: "black",
    borderRightWidth: 0,
    minHeight: "85%",
    // overflow: "hidden",
  }

})

export default styles;